export default {
    data() {
        return {
            options: {
                first :{
                    details:[
                        'Accès gratuit aux contacts des particuliers',
                        'Abonnement mensuel sans engagement, prix HT',
                        'Réservé aux 3 premiers pros souscripteurs par code postal',
                        '22% de rétrocession d\'honoraires, en cas de rdv mandat transformé'
                    ],
                    price: '89€HT /mois',
                    discounted: '',
                    duration: '',
                    group_discount: ''
                },
            }
        }
    }
}



// WEBPACK FOOTER //
// ./application/assets/js/shared/mixins/Pricing.js